(() => {
  if (window.bebiciaSearch) return;
  const searchPath = document.currentScript.dataset.searchUrl.replace(/\/$/, '');
  const clean = value => value.normalize('NFKC').trim().replace(/\s+/g, ' ');
  const decode = query => {
    query = query.replaceAll('&quot;', '"').replaceAll('&#39;', "'").replaceAll('&amp;', '&');
    if (!query.startsWith('(title:"')) {
      return query.replace(/\(([^()]+?) OR [^()]+\)/g, (_group, first) => first).replace(/ AND /g, ' ');
    }
    const terms = [...query.matchAll(/(?:^|\) AND )\(title:("(?:\\.|[^"\\])*")/g)];
    return terms.length ? terms.map(match => JSON.parse(match[1])).join(' ') : query;
  };
  const build = raw => clean(raw).split(' ').filter(Boolean).map(term => {
    // Keep SKU prefixes unquoted so Shopify can match the beginning of variant SKUs.
    if (/^[a-z0-9][a-z0-9_-]{2,}$/i.test(term)) return term;
    const alternatives = [term];
    if (term.includes('ズボン')) alternatives.push(term.replaceAll('ズボン', 'パンツ'));
    else if (term.includes('パンツ')) alternatives.push(term.replaceAll('パンツ', 'ズボン'));
    const synonymGroups = [
      ['水着', 'スイムウェア'],
      ['汗取りパッド', '汗取りパット'],
      ['よだれかけ', 'スタイ', 'ビブ'],
      ['おくるみ', 'スワドル'],
      ['靴下', 'ソックス'],
      ['上履き', '上靴'],
      ['長靴', '雨靴', 'レインシューズ', 'レインブーツ'],
      ['歯固め', '歯がため'],
      ['浮き輪', 'うきわ', 'フロート'],
      ['トイトレ', 'トイレトレーニング'],
      ['抱っこ紐', '抱っこひも'],
      ['おむつ', 'オムツ']
    ];
    for (const group of synonymGroups) {
      const matched = group.find(word => term.includes(word));
      if (matched) group.forEach(word => alternatives.push(term.replaceAll(matched, word)));
    }
    const words = [...new Set(alternatives)];
    // Use native search for Japanese trigram matching; field-scoped exact phrases hide partial names.
    const escaped = words.map(word => word.replace(/[\\":()]/g, character => '\\' + character));
    return escaped.length === 1 ? escaped[0] : '(' + escaped.join(' OR ') + ')';
  }).join(' AND ');
  window.bebiciaSearch = { build, decode };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (event.defaultPrevented || !form.matches('form.search')) return;
    const input = form.querySelector('input[type="search"]');
    const raw = input && clean(input.value);
    if (!raw) { event.preventDefault(); return; }
    const url = new URL(form.action, location.origin);
    if (url.pathname.replace(/\/$/, '') !== searchPath) return;
    event.preventDefault();
    url.search = new URLSearchParams(new FormData(form)).toString();
    url.searchParams.set('q', build(raw));
    url.searchParams.set('type', 'product,article');
    url.searchParams.set('options[prefix]', 'last');
    location.assign(url.href);
  });
  if (location.pathname.replace(/\/$/, '') === searchPath) {
    const url = new URL(location.href);
    const query = url.searchParams.get('q') || '';
    if (query.trim()) {
      const canonical = build(decode(query));
      if (query !== canonical || url.searchParams.get('type') !== 'product,article') {
        url.searchParams.set('q', canonical);
        url.searchParams.set('type', 'product,article');
        location.replace(url.href);
      }
    }
  }
})();
